import axios from 'axios'
import  { checkErrorData } from './authAction'
import  { formatList, orderByDateDsc, orderByDsc } from './format'
import { fetchUsers } from './userAction'

export function fetchCredits() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_CREDITS_START", payload: "" })
            console.log("fetch Credit START")
            const res = await axios.get('/credits/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_CREDITS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_CREDITS",
                    payload: formatList(orderByDateDsc(res.data, "credit_creation_date"), "credit_id")
                })
				dispatch({ type: "FETCH_CREDITS_FULFILLED", payload: "" })
                
			}            
        } catch(err) {
            console.log("[ERROR] get credits list ", err);
        }
    }
}
export function fetchDebits() {
    return async function(dispatch){
        try{
            dispatch({ type: "FETCH_DEBITS_START", payload: "" })
            console.log("fetch Credit START")
            const res = await axios.get('/credits/debit/get/all')
            console.log({res});
            
            if(checkErrorData(res, "FETCH_DEBITS_ERROR", dispatch ) ) {
                dispatch({
                    type: "GET_DEBITS",
                    payload: formatList(orderByDateDsc(res.data, "credit_creation_date"), "credit_id")
                })
				dispatch({ type: "FETCH_DEBITS_FULFILLED", payload: "" })
                
			}            
        } catch(err) {
            console.log("[ERROR] get credits list ", err);
        }
    }
}
export function recalcCredits() {
    return async function(dispatch){
        try{
            dispatch({ type: "RECALC_CREDITS_START", payload: "" })
            console.log("fetch Credit START")
            const res = await axios.get('/credits/recalc/all')
            console.log({res});
            
            if(checkErrorData(res, "RECALC_CREDITS_ERROR", dispatch ) ) {
                dispatch(fetchUsers())
				dispatch({ type: "RECALC_CREDITS_FULFILLED", payload: "" })
                
			}            
        } catch(err) {
            console.log("[ERROR] get credits list ", err);
        }
    }
}


export function newCredit(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_CREDIT_START", payload: "" })
            console.log("new Credit START", {data})
            const res = await axios.post('/credits/new',{data})
            console.log({res});

            if(checkErrorData(res, "CREATE_CREDIT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_CREDIT", payload: res.data })
                // update user account
                dispatch({ type: "DEBIT_USER_ACCOUNT", payload: {user_id: data.credit_user_id, amount: (data.credit_amount * -1)} })
				dispatch({ type: "CREATE_CREDIT_FULFILLED", payload: "" })
                return res.data // Retourner le crédit créé avec son ID
			}
        } catch(err) {
            console.log("[ERROR] new credit ", err);
            dispatch({
                type: "CREATE_CREDIT_ERROR",
                payload: err
            })
            throw err // Propager l'erreur pour la gestion dans le composant
        }
    }
}

export function fetchSubCredits(creditId) {
    return async function(dispatch){
        try{
            console.log("fetch SubCredits START", {creditId})
            const res = await axios.get(`/credits/${creditId}/subCredit`)
            console.log({res});

            if(checkErrorData(res, "FETCH_SUB_CREDITS_ERROR", dispatch ) ) {
                // L'API peut retourner { data: [...], pagination: {...} } ou directement un tableau
                if (res.data && Array.isArray(res.data)) {
                    return { data: res.data, pagination: { total: res.data.length } }
                } else if (res.data && res.data.data) {
                    return res.data // Format { data: [...], pagination: {...} }
                } else {
                    return { data: [], pagination: { total: 0 } }
                }
			}
        } catch(err) {
            console.log("[ERROR] fetch sub credits ", err);
            dispatch({
                type: "FETCH_SUB_CREDITS_ERROR",
                payload: err
            })
            return { data: [], pagination: { total: 0 } } // Retourner une structure vide en cas d'erreur
        }
    }
}

export function newSubCredit(creditId, subCreditData) {
    return async function(dispatch){
        try{
            console.log("new SubCredit START", {creditId, subCreditData})
            const res = await axios.post(`/credits/${creditId}/subCredit`, {data: subCreditData})
            console.log({res});

            if(checkErrorData(res, "CREATE_SUB_CREDIT_ERROR", dispatch ) ) {
                return res.data // Retourner le sous-crédit créé
			}
        } catch(err) {
            console.log("[ERROR] new sub credit ", err);
            dispatch({
                type: "CREATE_SUB_CREDIT_ERROR",
                payload: err
            })
            throw err // Propager l'erreur pour la gestion dans le composant
        }
    }
}

export function newDebit(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "CREATE_CREDIT_START", payload: "" })
            console.log("new debit START", {data})
            const res = await axios.post('/credits/debit/new', {data})
            console.log({res});

            if(checkErrorData(res, "CREATE_CREDIT_ERROR", dispatch ) ) {
                dispatch({ type: "NEW_DEBIT", payload: res.data })
                // update user account
                // update credit rest
                dispatch({ type: "UPDATE_CREDIT_REST", payload: res.data })
                dispatch({ type: "DEBIT_USER_ACCOUNT", payload: {user_id: data.credit_user_id, amount: data.credit_amount} })
				dispatch({ type: "CREATE_CREDIT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] new debit ", err);
            dispatch({
                type: "CREATE_CREDIT_ERROR",
                payload: err
            })
        }
    }
}

export function updateDebit(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "UPDATE_DEBIT_START", payload: "" })

            console.log("update Update START")
            const res = await axios.post("/credits/debits/update", {data})
            console.log({res});
            
            if (checkErrorData(res, "UPDATE_DEBIT_ERROR", dispatch ) ) {               
				dispatch({
                    type: "UPDATE_DEBIT",
                    payload: data
                })
				dispatch({ type: "UPDATE_DEBIT_FULFILLED", payload: "" })
			}
        } catch(err) {
            console.log("[ERROR] update debit ", err);
            dispatch({
                type: "UPDATE_DEBIT_ERROR",
                payload: err
                
            })
        }
    }
}


export function deleteCredit(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_CREDIT_START", payload: "" })

            console.log("delete credit START")
            const res = await axios.post("/credits/delete", {data: data.credit_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_CREDIT_ERROR", dispatch ) ) {
                dispatch({
                    type: "DELETE_CREDIT",
                    payload: data.credit_id,
                })
                dispatch({ type: "DELETE_CREDIT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete credit ", err);
            dispatch({
                type: "DELETE_CREDIT_ERROR",
                payload: err
            })
        }
    }
}
export function deleteDebit(data) {
    return async function(dispatch){
        try{
            dispatch({ type: "DELETE_DEBIT_START", payload: "" })

            console.log("delete debit START")
            const res = await axios.post("/credits/debit/delete", {data: data.credit_id})
            console.log({res});

            if(checkErrorData(res, "DELETE_DEBIT_ERROR", dispatch ) ) {
                data.credit_amount = data.credit_amount * -1
                dispatch({ type: "UPDATE_CREDIT_REST", payload: data })
                dispatch({ type: "DEBIT_USER_ACCOUNT", payload: {user_id: data.credit_user_id, amount: data.credit_amount } })
                dispatch({
                    type: "DELETE_DEBIT",
                    payload: data.credit_id,
                })

                dispatch({ type: "DELETE_DEBIT_FULFILLED", payload: "" })
            }

        } catch(err) {
            console.log("[ERROR] delete debit ", err);
            dispatch({
                type: "DELETE_DEBIT_ERROR",
                payload: err
            })
        }
    }
}
// export function deleteSupplierAdvance(advance_id) {
//     return async function(dispatch, getState){
//         try{
//             dispatch({ type: "DELETE_SUPPLIER_ADVANCE_START", payload: "" })

//             console.log("delete SupplierAdvance START")
//             const res = await axios.post("/suppliers/advance/delete", {data: advance_id})
//             console.log({res});

//             if(checkErrorData(res, "DELETE_SUPPLIER_ADVANCE_ERROR", dispatch ) ) {
//                 dispatch({
//                     type: "DELETE_SUPPLIER_ADVANCE",
//                     payload: advance_id
//                 })
//                 dispatch({ type: "DELETE_SUPPLIER_ADVANCE_FULFILLED", payload: "" })
//             }

//         } catch(err) {
//             console.log("[ERROR] delete advance ", err);
//             dispatch({
//                 type: "DELETE_SUPPLIER_ADVANCE_ERROR",
//                 payload: err
//             })
//         }
//     }
// }